import { useEffect, useRef, useState } from 'react'

import { ActivityhubClientActivity } from '@clinic/client'

import { useListEvents } from '../../shared/api'
import { Severity } from '../../shared/types'

interface LoadmoreProps {
  name: string
  severity?: Severity
  from: string
  to: string
}

export const useLoadmore = ({
  name,
  severity = Severity.Info,
  from,
  to
}: LoadmoreProps) => {
  const [dataList, setDataList] = useState<ActivityhubClientActivity[]>([])
  const remoteCursorRef = useRef<string>()
  const [refreshKeys, setRefreshKeys] =
    useState<(string | number | undefined)[]>()
  const { data, error } = useListEvents({
    name: name?.toLowerCase(),
    severity,
    from: Number(from),
    to: Number(to),
    keys: refreshKeys,
    cursor: remoteCursorRef.current
  })
  const loading = !data && !error
  const partial = !!data?.data?.partial

  const loadmore = (init = false) => {
    if (init) {
      setRefreshKeys([from, to, name, severity])
      setDataList([])
      remoteCursorRef.current = undefined
    } else {
      if (!partial) {
        return
      }
      setRefreshKeys([remoteCursorRef.current, from, to, name, severity])
    }
  }

  useEffect(() => {
    remoteCursorRef.current = data?.data?.cursor || undefined
    setDataList((list) => {
      return [...list, ...(data?.data.activities || [])]
    })
  }, [data])

  return { dataList, error, loading, partial, loadmore }
}
